import { Check } from '@mui/icons-material';
import { Divider, MenuItem, Typography } from '@mui/material';

import { PersonAvatar } from '@ll-platform/frontend/components/PersonAvatar/PersonAvatar';
import { useActiveUser } from '@ll-platform/frontend/core/auth/hooks/useActiveUser';
import { useOptionalActiveOrganization } from '@ll-platform/frontend/core/organization/ActiveOrganizationProvider';
import { organizationService } from '@ll-platform/frontend/core/organization/async/OrganizationsService';
import { Pages } from '@ll-platform/frontend/core/router/pages';
import { lemonlightOrganizationId } from '@ll-platform/shared-domain/const';
import { defined } from '@ll-platform/shared-utils/types';

export const OrganizationSwitcher = () => {
  const { activeUser } = useActiveUser();
  const { activeOrganization } = useOptionalActiveOrganization();

  const organizations = activeUser.organizations?.map(
    (organization) => organization.organization,
  );

  const handleSwitchOrganization = (organizationId: string) => {
    if (organizationId === activeOrganization?.id) {
      return;
    }

    organizationService.setOrganizationId(organizationId);
    window.location.assign(Pages.AuthRedirect);
  };

  if (!defined(organizations) || organizations.length < 2) {
    return <Divider />;
  }

  return (
    <>
      <Divider />

      <Typography
        variant="body2"
        sx={{
          px: 2,
          lineHeight: '24px',
          fontWeight: 500,
          color: 'text.secondary',
        }}
      >
        Organizations
      </Typography>

      {organizations.map((organization) => {
        const isActive = organization.id === activeOrganization?.id;
        const isLemonlight = organization.id === lemonlightOrganizationId;

        return (
          <MenuItem
            key={organization.id}
            onClick={() => handleSwitchOrganization(organization.id)}
            sx={{ gap: 2, py: 1.5 }}
          >
            <PersonAvatar
              variant="rounded"
              src={
                isLemonlight
                  ? '/static/images/logo/lemonlight-logo-icon-transparent.svg'
                  : undefined
              }
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: isLemonlight ? 'white' : undefined,
                padding: 0.5,
              }}
            >
              {organization.name[0]}
            </PersonAvatar>
            {organization.name}
            {isActive && <Check sx={{ ml: 'auto', color: 'text.secondary' }} />}
          </MenuItem>
        );
      })}

      <Divider sx={{ mt: '0 !important' }} />
    </>
  );
};
